import { types } from '@actions/snackbar';

export const initialState = {
  isVisible: false,
  success: true,
  message: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.DISPLAY:
      return {
        ...state,
        isVisible: true,
        success: action.success,
        message: action.message,
      };
    case types.HIDE:
      return {
        ...state,
        isVisible: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/snackbar.js